import React from 'react';
import { Modal } from 'react-bootstrap';
import './CustomModal.css';

const CustomModal = ({ 
  show, 
  onHide, 
  title, 
  subtitle,
  icon,
  iconVariant = 'gold',
  size = 'md',
  children,
  className = '',
  backdrop = true
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size={size}
      className={`custom-modal ${className}`}
      backdropClassName="custom-modal-backdrop"
      backdrop={backdrop === 'static' ? 'static' : backdrop}
    >
      <Modal.Header className="custom-modal-header">
        {!className?.includes('new-chat-modal') && (
          <button className="modal-close-btn" onClick={onHide}>
            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
        
        {(icon || title) && (
          <div className="modal-header-content">
            {icon && (
              <div className={`modal-icon modal-icon-${iconVariant}`}>
                {icon}
              </div>
            )}
            {title && <h3 className="modal-title">{title}</h3>}
            {subtitle && <p className="modal-subtitle">{subtitle}</p>}
          </div>
        )}
      </Modal.Header>
      
      <Modal.Body className="custom-modal-body">
        {children}
      </Modal.Body>
    </Modal>
  );
};

export default CustomModal;

